import { PageId } from '../../../constants';
import { BaseAddPage } from './base-add-page';
import { isBookingCalendarInstalled } from '../../editor-sdk-actions';

export class AddCalendarPage extends BaseAddPage {
  constructor(protected editorSDK, protected appToken, protected instance) {
    super(editorSDK, appToken, instance);
  }

  public async shouldAddPage(): Promise<boolean> {
    const bookingCalendarInstalled = await isBookingCalendarInstalled(
      this.editorSDK,
    );

    return !bookingCalendarInstalled;
  }

  public async execute() {
    await this.addBookingsPage(PageId.BOOKINGS_CALENDAR_PAGE);

    await this.createPageState(
      PageId.BOOKINGS_CALENDAR_PAGE,
      'bookingCalendar',
    );
  }

  protected get widgetId() {
    return '54d912c5-52cb-4657-b8fa-e1a4cda8ed01';
  }

  public get widgetName() {
    return 'AddCalendarPage';
  }

  public get stepTranslate() {
    return 'calendar-page-migration.progress-bar.step-1';
  }
}
